import APIClient from '@/services/APIClient';
import { SeatAPIModel } from '@/apiModels/SeatReservation';
import BaseServices from '@/services/BaseServices';
import { useQuery } from '@tanstack/react-query';
interface listSeatProps {
  eventId?: string;
  seatId?: string;
}

const useListSeat = ({ eventId, seatId }: listSeatProps) => {
  const apiClient = new APIClient<SeatAPIModel>(
    BaseServices.SEAT_RESERVATION_SERVICE,
    `/user-app/admin/seat/event/${eventId}/list-seat`,
  );

  return useQuery<SeatAPIModel[], Error>({
    queryKey: ['seat', eventId, seatId],

    queryFn: () =>
      apiClient.getList({
        area: seatId,
      }),
    enabled: !!eventId && !!seatId,
    retry: false,
  });
};

export default useListSeat;
